import { useSilver } from "@/context/SilverContext";
import { CAMPAIGN_ANGLES, CREATIVE_THEMES, FORMATS, SERVICES } from "@/data/content";

export function useCampaignLabels() {
  const { campaign } = useSilver();
  return {
    angleLabel: CAMPAIGN_ANGLES.find((a) => a.id === campaign.angle)?.title || null,
    creativeLabel: CREATIVE_THEMES.find((t) => t.id === campaign.creative)?.label || null,
    formatLabel: FORMATS.find((f) => f.id === campaign.format)?.label || null,
    serviceLabels: SERVICES.filter((s) => campaign.services.includes(s.id)).map((s) => s.label),
    message: campaign.message,
  };
}
